import { createContext } from "react";

const googleContext = createContext();

export default googleContext;
